import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import { PageTransition } from '../components/ui/PageTransition';
import { Footer } from '../components/layout/Footer';
import { SEO } from '../components/shared/SEO';
import { AnimatedSection } from '../components/ui/AnimatedSection';

export function Vote() {
  const { t } = useTranslation();
  
  const voteLinks = [
    {
      name: 'Minecraft-MP',
      url: 'https://minecraft-mp.com/server/306253/vote/'
    },
    {
      name: 'TopMinecraftServers',
      url: 'https://topminecraftservers.org/vote/28323'
    },
    {
      name: 'MinecraftPocket-Servers',
      url: 'https://minecraftpocket-servers.com/server/125287/vote/'
    },
    {
      name: 'MinecraftIPList',
      url: 'https://www.minecraftiplist.com/server/KaizenNetworkMinecraftServerIndonesia-37261/vote'
    },
    {
      name: 'MCServerTime',
      url: 'https://mcservertime.com/server-kaizen-network-server-indonesia.2636/vote'
    },
    {
      name: 'Minecraft-Server-List',
      url: 'https://minecraft-server-list.com/server/510684/vote/'
    },
    {
      name: 'Minecraft-ServerList',
      url: 'https://minecraft-serverlist.com/server/2429/vote'
    },
    {
      name: 'Top-MC-Servers',
      url: 'https://top-mc-servers.net/server/434'
    }
  ];

  return (
    <PageTransition>
      <SEO 
        title={t('seo.vote.title')}
        description={t('seo.vote.description')}
      />
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow flex items-center">
          <div className="w-full pt-36 pb-28">
            {/* Hero Section with Gradient Background */}
            <div className="relative mb-16">
              <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 via-gray-900/50 to-gray-900/90" />
              <div className="relative">
                <AnimatedSection animation="fade-down" className="text-center">
                  <h1 className="text-4xl sm:text-5xl font-bold mb-4">
                    <span className="bg-gradient-to-r from-primary-400 to-yellow-300 text-transparent bg-clip-text">
                      {t('vote.title')}
                    </span>
                  </h1>
                  <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                    {t('vote.description')}
                  </p>
                </AnimatedSection>
              </div>
            </div>

            <div className="max-w-7xl mx-auto px-4">
              <AnimatedSection animation="fade-up" delay>
                <div className="flex flex-wrap justify-center gap-6">
                  {voteLinks.map((site, index) => (
                    <a
                      key={site.name}
                      href={site.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group relative bg-gray-800/80 backdrop-blur-sm rounded-xl p-8 text-center border border-white/5 hover:border-white/10 transition-all flex flex-col items-center justify-center min-h-[200px] w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]"
                    >
                      <div className="absolute inset-0 bg-gradient-to-b from-primary-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" />
                      <AnimatedSection 
                        animation="fade-up" 
                        className="relative" 
                        delay={true}
                      >
                        <div className="flex items-center justify-center space-x-2 text-white text-xl font-semibold mb-6">
                          <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                            {site.name}
                          </span>
                          <ExternalLink className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors flex-shrink-0" />
                        </div>
                        <button className="relative px-8 py-3 text-black font-medium shadow-[0_0_0_rgba(248,203,8,0)] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] hover:shadow-[0_8px_16px_rgba(248,203,8,0.15)] bg-primary-500 hover:bg-yellow-400/90 rounded-lg">
                          {t('vote.voteNow')}
                        </button>
                      </AnimatedSection>
                    </a>
                  ))}
                </div>
              </AnimatedSection>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </PageTransition>
  );
} 